import styled from '@emotion/styled';
import { theme } from '@travelnest/hui';
import * as React from 'react';
import StyledHeading from '../typography/StyledHeading';

const StyledGreeting = styled(StyledHeading)`
	color: ${theme.colors.LM_NU100};
	margin: 24px 0;
`;

interface IGreetingProps {
	name?: string;
}

export const Greeting: React.FC<IGreetingProps> = ({ name }) => {
	const today = new Date();
	const curHr = today.getHours();
	let greeting = null;

	if (curHr < 12) {
		greeting = 'morning';
	} else if (curHr < 18) {
		greeting = 'afternoon';
	} else {
		greeting = 'evening';
	}

	const extendedGreeting = name ? `, ${name}` : '';

	return <StyledGreeting htmlElement="h2" lineHeight="sm" type="RWB130">
		Good {greeting}{extendedGreeting}!
	</StyledGreeting>;
};
